import { createActionCreator } from '../actions/actionCreators';
import { SettingsState } from './settings.reducer';

export const settingsStateLoading = createActionCreator('settingState/loading')();
export const settingsStateLoaded = createActionCreator('settingState/loaded')<SettingsState>();
export const settingsStateMissing = createActionCreator('settingState/missing')();
